const ExtraPayments = ({extraPayments, setExtraPayments}) => {
    return (
        <div className="formField">
        <label>Extra Payments:</label>
        <table className="table-default" style={{width: "100%", border: "1px solid #d1d5db"}}>
            <thead>
                <tr>
                    <th>Payment Number</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {extraPayments && extraPayments.length > 0 && extraPayments.map((payment, index) => 
                    <tr key={index}>
                        <td>
                            <input
                                type="number"
                                defaultValue={payment.paymentNumber}
                                step="1"
                                min="1"
                                onChange={(e) => {
                                    const newExtraPayments = [...extraPayments]
                                    newExtraPayments[index] = {
                                        ...newExtraPayments[index],
                                        paymentNumber: parseInt(e.target.value)
                                    }

                                    setExtraPayments(newExtraPayments)
                                }}
                            />
                        </td>
                        <td>
                            <input
                                type="number"
                                defaultValue={payment.amount}
                                step="any"
                                onChange={(e) => {
                                    const newExtraPayments = [...extraPayments]
                                    newExtraPayments[index] = {
                                        ...newExtraPayments[index],
                                        amount: parseFloat(e.target.value)
                                    }

                                    setExtraPayments(newExtraPayments)
                                }}
                            />
                        </td>
                        <td>
                            <button
                                type="button"
                                className="button button-slim button-red"
                                onClick={() => {
                                    const newExtraPayments = [...extraPayments]
                                    newExtraPayments.splice(index, 1)
                                    setExtraPayments(newExtraPayments)
                                }}
                            >
                                x
                            </button>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
        <button
            type="button"
            className="button button-slim button-blue" style={{width: "100%"}}
            onClick={() => setExtraPayments([...extraPayments, 0])}
        >
            +
        </button>
    </div>
    )
}

export default ExtraPayments